import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Daytona Local - Daytona Beach Local Events, Attractions and Dining Guide'
      }
    },
    {
      path: '/organizers',
      name: 'organizers',
      component: () => import(/* webpackChunkName: "organizers" */ './views/Organizers.vue'),
      meta: {
        title: 'Daytona Local - Organizers Area'
      }
    },
    {
      path: '/advertisers',
      name: 'advertisers',
      component: () => import(/* webpackChunkName: "advertisers" */ './views/Advertisers.vue'),
      meta: {
        title: 'Daytona Local - Advertisers Area'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/NewsList.vue'),
      meta: {
        title: 'Daytona Local - News'
      }
    },
    {
      path: '/news-details/:url',
      name: 'news-details',
      component: () => import(/* webpackChunkName: "news-details" */ './views/NewsDetail.vue'),
    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './views/EventList.vue'),
      meta: {
        title: 'Daytona Local - Events'
      }
    },
    {
      path: '/event-details/:url',
      name: 'event-details',
      component: () => import(/* webpackChunkName: "event-details" */ './views/EventDetail.vue'),
    },
    {
      path: '/attractions',
      name: 'attractions',
      component: () => import(/* webpackChunkName: "attractions" */ './views/AttractionList.vue'),
      meta: {
        title: 'Daytona Local - Attractions'
      }
    },
    {
      path: '/attraction-details/:url',
      name: 'attraction-details',
      component: () => import(/* webpackChunkName: "attraction-details" */ './views/AttractionDetail.vue')
    },
    {
      path: '/parks',
      name: 'parks',
      component: () => import(/* webpackChunkName: "parks" */ './views/ParkList.vue'),
      meta: {
        title: 'Daytona Local - Parks'
      }
    },
    {
      path: '/park-details/:url',
      name: 'park-details',
      component: () => import(/* webpackChunkName: "park-details" */ './views/ParkDetail.vue')
    },
    {
      path: '/dining',
      name: 'dining',
      component: () => import(/* webpackChunkName: "dining" */ './views/DiningList.vue'),
      meta: {
        title: 'Daytona Local - Dining'
      }
    },
    {
      path: '/restaurant-details/:url',
      name: 'restaurant-details',
      component: () => import(/* webpackChunkName: "restaurant-details" */ './views/RestaurantDetail.vue')
    },
    {
      path: '/submit-event/',
      name: 'submit-event',
      component: () => import(/* webpackChunkName: "submit-event" */ './views/SubmitEvent.vue'),
      meta: {
        title: 'Daytona Local - Submit Event'
      }
    },
    {
      path: '/support/',
      name: 'support',
      component: () => import(/* webpackChunkName: "support" */ './views/Support.vue'),
      meta: {
        title: 'Daytona Local - Support & Contact'
      }
    },
    {
      path: '/admin/',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      meta: {
        title: 'Daytona Local - Admin'
      }
    },
    // {
    //   path: '/sitemap/',
    //   name: 'sitemap',
    //   component: () => import(/* webpackChunkName: "sitemap" */ './views/sitemap.vue'),
    //   meta: {
    //     title: 'Daytona Local - Sitemap'
    //   }
    // }
  ]
})

router.afterEach((nextRoute, from) => {
  Vue.nextTick(() => {
    document.title = nextRoute.meta.title
  })
})

export default router
